import { CustomDataTable } from "../common/CustomDataTable";
import PageLayout from "../PageLayout";

export default function DynamicListingPage({
    icon,
    pageTitle,
    ...rest
}) {

    return (
        <PageLayout icon={icon} pageTitle={pageTitle} >
            <CustomDataTable
                {...rest}
            />
        </PageLayout>
    );
};